import { ALLOW_LIST } from '../components/Authentication/AllowListedUsers';

export const LEGAL_REPORT_ALLOW_LIST: Set<string> = new Set<string>([
  ...Array.from(ALLOW_LIST),
  '101539157', // jurcikb
  '105361155', // caroques
  '104554990', // nvardan
  '108889451', // ezavrelo
  '107403836', // souilmih
  '106540545', // jcmelik
  '108587830', // blahovma
  '101271871', // lanovenk
  '101292302', // lstejska
  '103735606', // laradieg
  '108051387', // qkoudlan
  '103034351', // pulpano
  '205959648', // ievgents
  '113139558', // jahrdin
  '101618147', // nondrej
  '205939340', // bgiftjer
  '206063396', // ubasinri
  '207581689', // umichmil
  '207581691', // kenvchan
  '101664204' // allmike
]);
